"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADVISOR_APP_VIEWED_EVENTS = exports.mortgageRefiClosingFees = exports.featureFlagConfig = void 0;
/* @TranslateToPython @TranslateToEnum */
exports.featureFlagConfig = {
    paidReferrals: true,
    creditOffers: false,
    experianBoostEnabled: false,
};
// Default values for mortgage refi closing fee breakdowns
exports.mortgageRefiClosingFees = {
    originationFeeRate: 0.01,
    appraisalFee: 500,
    titleInsuranceAndSearch: 1000,
    creditReportFee: 50,
    attorneyFees: 1000,
    surveyFee: 500,
    recordingFee: 100,
    underwritingFee: 500,
    escrowDeposit: 4000,
    daysUntilFirstPayment: 15,
};
/** @TranslateToPython
 * Events that indicate an advisor actively viewed the app's main page (not via push notification deeplink).
 * This is the single source of truth for "what viewing the advisor app means".
 * Values must match FrontendAnalyticsEventName enum: viewAdvisorTodayTab, viewAdvisorV2Dashboard
 */
exports.ADVISOR_APP_VIEWED_EVENTS = ['view_advisor_today_tab', 'view_advisor_v2_dashboard'];
